import { useState, useEffect } from 'react';
import { supabase } from '../../../../lib/supabase';
import { useAuth } from '../../../../hooks/useAuth';

export default function StatsRow() {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    storiesRead: 0,
    bookmarked: 0,
    commentsLeft: 0,
    following: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      if (!user?.id) return;

      try {
        // Get stories read count
        const { count: readCount } = await supabase
          .from('reading_history')
          .select('*', { count: 'exact', head: true })
          .eq('user_id', user.id);

        // Get bookmarked count
        const { count: bookmarkCount } = await supabase
          .from('bookmarks')
          .select('*', { count: 'exact', head: true })
          .eq('user_id', user.id);

        // Get comments left count
        const { count: commentCount } = await supabase
          .from('comments')
          .select('*', { count: 'exact', head: true })
          .eq('author_id', user.id);

        setStats({
          storiesRead: readCount || 0,
          bookmarked: bookmarkCount || 0,
          commentsLeft: commentCount || 0,
          following: 0 // Placeholder for future following feature
        });
      } catch (error) {
        console.error('Error fetching stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [user?.id]);

  const statsData = [
    { label: 'Stories Read', value: stats.storiesRead },
    { label: 'Bookmarked', value: stats.bookmarked },
    { label: 'Comments', value: stats.commentsLeft },
    { label: 'Following', value: stats.following }
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-zinc-950 border border-red-900/30 rounded-lg p-6 text-center animate-pulse"
          >
            <div className="h-9 bg-zinc-900 rounded mb-2"></div>
            <div className="h-5 bg-zinc-900 rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
      {statsData.map((stat) => (
        <div
          key={stat.label}
          className="bg-zinc-950 border border-red-900/30 rounded-lg p-6 text-center"
        >
          <div className="text-3xl font-bold text-red-400 mb-2">{stat.value}</div>
          <div className="text-zinc-500 text-sm font-medium">{stat.label}</div>
        </div>
      ))}
    </div>
  );
}